import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, Tooltip } from "@mui/material";
import { keyframes } from "@mui/system";
import { useNavigate } from "react-router-dom";


const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;


const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 101, 255, 0.5);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(0, 101, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 101, 255, 0);
  }
`;

const FloatingContactButton: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    const section = document.getElementById("contact-section");

    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/#contact-section");
    }
  };

  return (
    <Tooltip title="" placement="left">
      <Box
        onClick={handleClick}
        sx={{
          position: "fixed",
          bottom: { xs: "20px", md: "30px" },
          right: { xs: "20px", md: "30px" },

          width: { xs: "56px", md: "64px" },
          height: { xs: "56px", md: "64px" },
          borderRadius: "50%",

          background:
            "linear-gradient(135deg, #64e7a5 0%, #0065ff 100%)",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",

          zIndex: 9999,

          // ✨ Animations
          animation: `${floatAnimation} 3s ease-in-out infinite, ${pulseAnimation} 2.5s infinite`,

          transition: "all 0.3s ease",

        
        }}
      >
        <PhoneIcon sx={{ color: "#fff", fontSize: 28 }} />
      </Box>
    </Tooltip>
  );
};

export default FloatingContactButton;